/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Concepts_NoteInputs */

const en_projects_concepts_note = /** @type {(inputs: Projects_Concepts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design explorations`)
};

const lv_projects_concepts_note = /** @type {(inputs: Projects_Concepts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizaina pētījumi`)
};

/**
* | output |
* | --- |
* | "Design explorations" |
*
* @param {Projects_Concepts_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_concepts_note = /** @type {((inputs?: Projects_Concepts_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Concepts_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_concepts_note(inputs)
	return en_projects_concepts_note(inputs)
});